<div class="card p-6!" *transloco="let t; prefix: 'wizard.company'">
  <h3 class="text-white text-lg mb-4 font-semibold" data-testid="country-heading">
    {{ t('operatesIn') }}:
  </h3>
  <div>
    @for (control of countrySelectionControls.controls; track $index) {
      <div class="mb-6">
        <div class="flex items-center gap-4">
          <div class="flex-1">
            <div class="flex flex-col gap-2">
              <label for="country{{ $index }}">
                {{ t('selectCountryLabel') }}
              </label>
              <div class="flex items-center gap-5">
                <app-country-select
                  class="w-full"
                  [formControl]="control"
                  [excludeCountryCodes]="getExcludedCountryCodes($index)"
                  [placeholder]="t('selectCountryPlaceholder')"
                  [testId]="'country-select-' + $index"
                ></app-country-select>
                @if ($count > 1) {
                  <button
                    class="text-gray-400 hover:text-gray-300 transition-colors p-2"
                    (click)="removeCountryDropdown($index)"
                    [disabled]="!isCountryDeletable($index)"
                    [pTooltip]="
                      !isCountryDeletable($index) ? t('countryCannotBeDeleted') : undefined
                    "
                    [attr.data-testid]="'delete-country-' + control.value"
                  >
                    <i class="pi pi-trash"></i>
                  </button>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
  <button
    class="flex items-center gap-2 text-gray-400 hover:text-gray-300 transition-colors"
    (click)="addCountryDropdown()"
    data-testid="add-country-button"
  >
    <i class="pi pi-plus-circle"></i>
    <span>{{ t('addCountry') }}</span>
  </button>
</div>
